module.exports = __webpack_public_path__ + "img/star.2400a569.svg";